export default "/images/c78705190a0b791be7031bd24014233d.avif";